module.exports = __webpack_public_path__ + "static/media/ursina_badilatti.5fb01df5.jpg";